import { useState, useRef } from 'react';
import { useClickOutside } from '../hooks/useClickOutside';

export interface MenuProps {
  key: number;
  label: JSX.Element;
}

interface Props {
  menu: MenuProps[];
  children: JSX.Element;
  placement?: 'bottom' | 'bottomLeft' | 'bottomRight' | 'top' | 'topLeft' | 'topRight';
  onClickItem?: () => void;
}

export function HoverDropdown({ menu, children, placement = 'bottom' }: Props) {
  const [dropDownOpen, setDropDownOpen] = useState(false);
  const dropDownRef = useRef(null);

  useClickOutside(dropDownRef, () => setDropDownOpen(false));

  const bottom = placement === 'bottom' ? 'top-[110%] -left-1/2' : '';
  const bottomLeft = placement === 'bottomLeft' ? 'top-[110%] right-0' : '';
  const bottomRight = placement === 'bottomRight' ? 'top-[110%] left-0' : '';
  const top = placement === 'top' ? 'bottom-[110%] -left-1/2' : '';
  const topLeft = placement === 'topLeft' ? 'bottom-[110%] right-0' : '';
  const topRight = placement === 'topRight' ? 'bottom-[110%] left-0' : '';

  return (
    <div ref={dropDownRef} className="relative w-max">
      <div className="flex items-center justify-between" onClick={() => setDropDownOpen(!dropDownOpen)}>
        {children}
      </div>

      {dropDownOpen && (
        <div
          className={`z-30 absolute ${bottom} ${bottomLeft} ${bottomRight} ${top} ${topLeft} ${topRight}
        py-2 w-max flex flex-col bg-white rounded-md border drop-shadow-md divide-y-2`}
        >
          {menu.map((menu) => menu.label)}
        </div>
      )}
    </div>
  );
}

export function DropDownItem({ label, onClick }: { label: string; onClick?: () => void }) {
  return (
    <h3
      onClick={() => onClick && onClick()}
      className="w-full text-sm px-4 py-2 hover:bg-neutralBlue2 rounded-md cursor-pointer"
    >
      {label}
    </h3>
  );
}
